import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import { DateRangePicker } from 'react-dates';
import { ReactComponent as Back } from 'Icons/back-bordered.svg';
import { ReactComponent as Forward } from 'Icons/forward-bordered.svg';
import Moment from 'moment';
import { Link } from 'react-router-dom';
import Dropdown from 'Components/Dropdown';
import { ReactComponent as BackIcon } from 'Icons/back.svg';
import { ReactComponent as DeleteIcon } from 'Icons/delete.svg';
import { ReactComponent as EditIcon } from 'Icons/edit.svg';
import { ReactComponent as CancelIcon} from 'Icons/cancel.svg';
import { ReactComponent as SaveIcon } from 'Icons/save.svg';
import { GET_UPLOAD_PLAN, POST_UPLOAD_PLAN, UPDATE_UPLOAD_PLAN, DELETE_UPLOAD_PLAN, GET_CONSIGNEE, DOWNLOAD_UP_TEMPLATE, UPLOAD_UP_FILE } from 'Constants/actionConstants';
import { getCookie } from 'Utils/storage';
import Upload from 'Components/Upload';
import { ReactComponent as DownloadIcon } from 'Icons/download.svg';

class UploadPlan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            startDate: null,
            endDate: null,
            offset: 0,
            limit: 10,
            uploadPlanDetails: null,
            editId: '',
            downloadTemp: ''
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;
        const tegUser = JSON.parse((getCookie('teg-user')));
        const companyId = tegUser.companyId;
        const branchId = tegUser.branchId;
        dispatch({
            type: GET_CONSIGNEE,
            params: {
                companyId,
                branchId
            },
            onSuccess: () => {
                this.getUploadPlan();
            }
        })
        
    }

    getUploadPlan = () => {
        const { dispatch } = this.props;
        const tegUser = JSON.parse((getCookie('teg-user')));
        const companyId = tegUser.companyId;
        const branchId = tegUser.branchId;
        dispatch({
            type: GET_UPLOAD_PLAN,
            params: {
                companyId,
                branchId
            },
            onSuccess: (data) => {
                this.setState({uploadPlanDetails: data})
            }
        });
    }

    addUploadPlan = () => {
        const { uploadPlanDetails } = this.state;
        const tegUser = JSON.parse((getCookie('teg-user')));
        const company_id = tegUser.companyId;
        const newUploadPlan = {
            company_id,
            consignee: {},
            from: "",
            to: "",
            dispatch_date_from: null,
            dispatch_date_to: null,
            quantity: 0,
            vehicle_type: {}
        }
        this.setState({ uploadPlanDetails : [newUploadPlan, ...uploadPlanDetails]})
    }

    saveUploadPlan = (data) => {
        const { dispatch } = this.props;
        dispatch({
            type: data.uploadplan_id ? UPDATE_UPLOAD_PLAN : POST_UPLOAD_PLAN,
            data,
            onSuccess: () => {
                this.setState({editId: null})
                this.getUploadPlan();
            }
        })
        
    }

    setVehicleType = (vehicleType, index)=> {
        const { uploadPlanDetails } = this.state;
        uploadPlanDetails[index].vehicle_type = vehicleType;
        this.setState({ uploadPlanDetails });
    }

    selectConsignee = (consignee, index) => { 
        const { uploadPlanDetails } = this.state;
        uploadPlanDetails[index].consignee.company_id = consignee.company_id;
        uploadPlanDetails[index].consignee.location_network_id = consignee.location_network_id;
        uploadPlanDetails[index].consignee.company_name = consignee.company_name;
        this.setState({
            uploadPlanDetails
        })
    }
    
    editUploadPlan = (id) => {
        const { uploadPlanDetails } = this.state;
        this.setState({
            editId: this.state.editId===id ? null : id,
            uploadPlanDetails,
        });
     }

    deleteUploadPlan = (id) => {
        const { dispatch } = this.props;
        dispatch({
            type: DELETE_UPLOAD_PLAN,
            params: {uploadplanId: id},
            onSuccess: () => {
                this.getUploadPlan();
            }
        })
    }

    cancelAction = (uploadplanId, index) => {
        if(uploadplanId){
          this.setState({
            editId: null,
            }) 
        } else {
          const { uploadPlanDetails } = this.state;
          uploadPlanDetails.splice(index,1);
          this.setState({
            uploadPlanDetails
          })
        }
    }

    onChangeInput = (record, index, event) => {
        const { uploadPlanDetails } = this.state;
        const { name, value } = event.target;
        uploadPlanDetails[index][name] = value;

        this.setState({
            uploadPlanDetails
            });
    };

    handleDateChange(startDate, endDate, index) {
        const { uploadPlanDetails } = this.state;
        uploadPlanDetails[index].dispatch_date_from = startDate ? Moment(startDate).format('DD-MM-YYYY') : null;
        uploadPlanDetails[index].dispatch_date_to = endDate ? Moment(endDate).format('DD-MM-YYYY') : null;
        this.setState({uploadPlanDetails});
    }
    
    // onChange = (file) => {
	// 	this.uploadServiceCategory(file);
    // }

    uploadRecord = (file) => {
        const { dispatch } = this.props;
        const tegUser = JSON.parse((getCookie('teg-user')));
        const companyId = tegUser.companyId;
		dispatch({
			type: UPLOAD_UP_FILE,
            file: file,
            params: {companyId},
            onSuccess: () => {
                this.getUploadPlan();
            }
		})

    }
    
    downloadRecord = (isData) => {
        const { dispatch } = this.props;
        const tegUser = JSON.parse((getCookie('teg-user')));
        const companyId = tegUser.companyId;
		dispatch({
            type: DOWNLOAD_UP_TEMPLATE,
            params: {
                companyId,
                withData: isData,
            },
			onSuccess: ((data) => {
                if (data) {
                    const element = document.createElement('a');
                    element.setAttribute('href', data.url);
                    element.setAttribute('download', true);
                    
                    element.click();
                }
			})
		})
	}

    renderTableHeaders = () => {
        return (
            <div className="pl-20 pr-20 pb-10">
                <div>
                        <Link className="ht-30 flex flex-middle wt-max-content mb-10 mt-5" to={"/seeker"}>
                        <BackIcon className="mr-10 fill-theme curP fBold"/>Back</Link>
                    </div>
                <div className="mt-20 text-center col-1 fBold fs-24 mb-10">Upload Plan
                <div className="fRight">
                    <button
                        onClick={this.addUploadPlan}
                        className={"ht-25 wt-150 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30"}>
                        Add Record
                    </button>
                    <button className="ht-25 wt-200 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={() => this.downloadRecord(true)}>Download Record</button>
                </div>
                </div>
                <div className="fRight mb-20">
                    <Upload onChange={this.uploadRecord}>
                        <button className="ht-25 wt-150 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" >Upload</button>
                    </Upload>
                    <button className="ht-25 wt-200 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={() => this.downloadRecord(false)}>Download Temp.</button>
                </div>
                {/* </div> */}
                
          <div className="wt-100p flex pb-15 border-bottom-light-2">
            <div className="wt-20p fSemibold fs-16 ml-20"> Cutomer Name </div>
            <div className="wt-10p fSemibold fs-16 ml-30 mr-30"> From </div>
            <div className="wt-10p fSemibold fs-16 ml-40 mr-30"> To </div>
            <div className="wt-20p fSemibold fs-16 ml-40 mr-40"> Dispatch Date</div>
            <div className="wt-10p fSemibold fs-16 ml-60"> Quantity</div>
            <div className="wt-20p fSemibold fs-16 ml-10"> Vehicle Type</div>
            <div className="wt-10p fSemibold fs-16 ml-40"> Action </div>
          </div></div>
        );
      }

      renderTableDetails = (records, index, vehicleTypes, consigneeList) => {
        const { editId } = this.state;
        return (
            
                    <div className="flex flex-betweeen mb-10 pr-10 mt-10 d-block text-center">
                        <div className="col-3 mt-5 ml-5 mb-2 mr-5 w-inherit text-center">
                            {(records.uploadplan_id !== editId) && records.uploadplan_id ? <div className="fs-14 wt-25p ml-10"> {records.consignee.company_name} </div> :
                            <Dropdown 
                                onSelect={(options) => this.selectConsignee(options, index)}
                                items={consigneeList} selectedItem={consigneeList.find((consignee)=> {
                                    return consignee.branch_name === records.consignee.company_name
                                })} 
                                label="Select Customer Name" 
                                displayKey="company_name"
                                searchEnabled={true}
                                searchPlaceholder={'Search Customer Name'}
                            /> }
                        </div>
                        <div className="col-4 mt-5 ml-5 mb-2 mr-5 w-inherit text-center">
                        {(records.uploadplan_id !== editId) && records.uploadplan_id ? <div className="fs-14 wt-25p ml-10"> {records.from} </div> :
                            <input
                                // readOnly={false}
                                name="from"
                                placeholder="From Location"
                                onChange={e => this.onChangeInput(records, index, e)}
                                value={records.from || ''}
                                className="pl-10 fs-16 border-light ht-40 col-1 br-5 mb-20"
                            />}
                        </div>
                        <div className="col-4 mt-5 ml-5 mb-2 mr-5 w-inherit text-center">
                        {(records.uploadplan_id !== editId) && records.uploadplan_id ? <div className="fs-14 wt-25p ml-10"> {records.to} </div> :
                            <input
                                // readOnly={false}
                                name="to"
                                placeholder="To Location"
                                onChange={e => this.onChangeInput(records, index, e)}
                                value={records.to || ''}
                                className="pl-10 fs-16 border-light ht-40 col-1 br-5 mb-20"
                            />}
                        </div>
                        <div className="col-2 mt-5 ml-5 mb-10 w-inherit text-center">
                        {(records.uploadplan_id !== editId) && records.uploadplan_id ? <div className="fs-14 wt-25p ml-10"> {records.dispatch_date_from + ' to ' + records.dispatch_date_to} </div> :
                            <DateRangePicker
                                startDate={records.dispatch_date_from ? Moment(records.dispatch_date_from,'DD-MM-YYYY') : null}
                                startDateId="startDate"
                                endDate={records.dispatch_date_to ? Moment(records.dispatch_date_to,'DD-MM-YYYY') : null}
                                endDateId="endDate"
                                onDatesChange={({ startDate, endDate }) => { 
                                    this.handleDateChange(startDate, endDate, index) }}
                                focusedInput={this.state.focusedInput}
                                onFocusChange={focusedInput => this.setState({ focusedInput: true ? focusedInput : null })}
                                displayFormat={'DD-MM-YYYY'}
                                noBorder={true}
                                minimumNights={0}
                                isOutsideRange={() => false}
                            />}
                        </div>
                        <div className="col-8 mt-5 ml-5 mb-2 mr-5 w-inherit text-center">
                        {(records.uploadplan_id !== editId) && records.uploadplan_id ? <div className="fs-14 wt-25p ml-10"> {records.quantity} </div> :
                            <input
                                // readOnly={false}
                                name="quantity"
                                placeholder="Quantity"
                                onChange={e => this.onChangeInput(records, index, e)}
                                value={records.quantity || ''}
                                className="pl-10 fs-16 border-light ht-40 col-1 br-5 mb-20"
                            />}
                        </div>
                        <div className="col-3 mt-5 ml-5 mb-2 mr-5 w-inherit text-center">
                        {(records.uploadplan_id !== editId) && records.uploadplan_id ? <div className="fs-14 wt-25p ml-10"> {records.vehicle_type.name} </div> :
                            <Dropdown 
                                onSelect={(options) => this.setVehicleType(options, index)}
                                items={vehicleTypes} selectedItem={vehicleTypes.find((vehicleType)=> {
                                    return vehicleType.name === records.vehicle_type.name
                                })} 
                                label="Select Vehicle Type" 
                                displayKey="name"
                                searchEnabled={true}
                                searchPlaceholder={'Search Vehicle Types'}
                            />
                            }
                        </div>
                        <div className="col-9 mt-5 ml-10 mb-2 mr-10 w-inherit text-center">
                        {(records.uploadplan_id === editId) || !records.uploadplan_id ? 
                            <Fragment>
                                <CancelIcon className="wt-20 ht-20 ml-10 curP fBold" onClick={(e) => this.cancelAction(records.uploadplan_id,index)} />
                                <SaveIcon className="wt-20 ht-20 ml-10 curP" onClick={() => this.saveUploadPlan(records)} />
                                
                            </Fragment> :
                            <Fragment>
                                <EditIcon className="wt-20 ht-20 ml-10 curP fBold" onClick={() => this.editUploadPlan(records.uploadplan_id)} />
                                <DeleteIcon className="wt-20 ht-20 ml-10 curP" onClick={() => this.deleteUploadPlan(records.uploadplan_id)} /> 
                            </Fragment>}
                        </div>
                    </div>
                
        )
    }
    render() {
      
        const { vehicleTypes, consigneeList } = this.props;
        const { uploadPlanDetails } = this.state;
        return (
          <div className="ph-20 pv-20">
            {this.renderTableHeaders()}
            
            {
              uploadPlanDetails && uploadPlanDetails.map((item, index) => {
                
                return this.renderTableDetails(item, index, vehicleTypes, consigneeList);
                
              })
            }
          </div>
        );
      }
}

const mapStateToProps = ({ constants}) => {
    return {
        vehicleTypes: constants.vehicleTypes || [],
        uploadPlans: constants.uploadPlans || [],
        consigneeList: constants.consigneeList || []
    };
};


export default connect(mapStateToProps)(UploadPlan);
